import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagPL(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <mask id="icon-flag-pl" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <circle cx="12" cy="12" r="12" fill="#fff" />
      </mask>
      <g mask="url(#icon-flag-pl)">
        <path
          fill="#DC143C"
          d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12H0Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12h24Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <circle cx={12} cy={12} r={11.5} stroke="#3C3C60" strokeOpacity={0.1} />
      </g>
    </BaseIcon>
  );
}
